import { useState } from 'react';
import axios from 'axios';

const SUB_API_BASE = 'https://teardrophydro.co.uk/garageFarm/subscriptions';

export const SLOT_LABELS = { morning: 'Late morning (10:30am–1pm)', evening: 'Early evening (5:30–7pm)', late: 'Late evening (7–9pm)' };

export function subscriptionUrgency(sub) {
  const isToday = sub.nextDeliveryDate
    && new Date(sub.nextDeliveryDate).toDateString() === new Date().toDateString();
  const isTomorrow = sub.nextDeliveryDate
    && new Date(sub.nextDeliveryDate).toDateString() === new Date(Date.now() + 86400000).toDateString();
  const isOverdue = sub.nextDeliveryDate
    && new Date(sub.nextDeliveryDate) < new Date(new Date().setHours(0, 0, 0, 0));
  return { isToday, isTomorrow, isOverdue };
}

export const UpcomingDeliveryCard = ({ sub, onDone, compact = false }) => {
  const [state, setState] = useState('idle'); // idle | charging | done | error
  const [msg,   setMsg]   = useState('');

  const token = () => localStorage.getItem('accessToken');

  const chargeAndAdvance = async () => {
    if (!sub.pricePerDelivery) {
      setMsg('No price set - go to Subscribers to set one first.'); return;
    }
    if (!window.confirm(`Charge £${sub.pricePerDelivery.toFixed(2)} to ${sub.customerId?.name || 'customer'}?`)) return;
    setState('charging'); setMsg('');
    try {
      await axios.post(`${SUB_API_BASE}/${sub._id}/charge`,
        { amount: sub.pricePerDelivery, advanceAfter: true },
        { headers: { Authorization: `Bearer ${token()}` } }
      );
      setState('done'); setMsg('Charged and delivery date advanced.');
      setTimeout(onDone, 1500);
    } catch (e) {
      setState('error'); setMsg(e.response?.data?.error || 'Charge failed');
    }
  };

  const advanceOnly = async () => {
    setState('charging'); setMsg('');
    try {
      await axios.post(`${SUB_API_BASE}/${sub._id}/advance-delivery`,
        {},
        { headers: { Authorization: `Bearer ${token()}` } }
      );
      setState('done'); setMsg('Delivery date advanced.');
      setTimeout(onDone, 1500);
    } catch {
      setState('error'); setMsg('Failed to advance delivery date.');
    }
  };

  const c = sub.customerId;
  const addr = sub.deliveryAddress;
  const addrStr = addr?.line1
    ? [addr.line1, addr.line2, addr.city, addr.postcode].filter(Boolean).join(', ')
    : null;
  const nextDate = sub.nextDeliveryDate
    ? new Date(sub.nextDeliveryDate).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' })
    : '-';
  const { isToday, isTomorrow, isOverdue } = subscriptionUrgency(sub);
  const urgencyLabel = isOverdue ? 'Overdue' : isToday ? 'Today' : isTomorrow ? 'Tomorrow' : nextDate;
  const urgencyColor = (isOverdue || isToday) ? '#dc2626' : isTomorrow ? '#d97706' : '#4f46e5';

  return (
    <div style={{
      background: 'var(--panel)', border: '1px solid var(--border)', borderRadius: 'var(--r-xl)',
      padding: compact ? '10px 12px' : '14px 16px', display: 'flex', flexDirection: 'column', gap: compact ? 4 : 8,
      borderLeft: `4px solid ${urgencyColor}`,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 14 }}>{c?.name || '-'}</div>
          {!compact && c?.phone && <a href={`tel:${c.phone}`} style={{ fontSize: 12, color: 'var(--brand-2)', textDecoration: 'none' }}>📞 {c.phone}</a>}
          {!compact && !c?.phone && c?.email && <div style={{ fontSize: 12, color: 'var(--muted)' }}>{c.email}</div>}
        </div>
        <span style={{ background: urgencyColor, color: '#fff', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 99, whiteSpace: 'nowrap' }}>
          {urgencyLabel}
        </span>
      </div>

      <div style={{ fontSize: 12, color: 'var(--text)', lineHeight: 1.5 }}>
        {sub.type === 'surprise'
          ? <span style={{ fontStyle: 'italic' }}>🎲 Surprise box{sub.preferences ? ` - "${sub.preferences}"` : ''}</span>
          : <span>✏️ {(sub.items || []).map(i => `${i.name}${i.quantity ? ` (${i.quantity})` : ''}`).join(', ') || 'Custom box'}</span>
        }
      </div>

      {!compact && addrStr && <div style={{ fontSize: 12, color: 'var(--muted)' }}>📍 {addrStr}</div>}
      {!compact && sub.deliveryInstructions && <div style={{ fontSize: 12, color: 'var(--muted)', fontStyle: 'italic' }}>"{sub.deliveryInstructions}"</div>}
      {sub.deliverySlot && <div style={{ fontSize: 12, color: 'var(--muted)' }}>🕐 {SLOT_LABELS[sub.deliverySlot] || sub.deliverySlot}</div>}

      {!compact && (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 4 }}>
          {state === 'done' ? (
            <span style={{ fontSize: 12, color: '#16a34a', fontWeight: 600 }}>✓ {msg}</span>
          ) : (
            <>
              <button
                onClick={advanceOnly}
                disabled={state === 'charging'}
                style={{ background: 'var(--panel-2)', color: 'var(--muted)', border: 'none', borderRadius: 'var(--r-md)', padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
              >
                Mark delivered (no charge)
              </button>
              {state === 'error' && <span style={{ fontSize: 12, color: '#dc2626' }}>{msg}</span>}
            </>
          )}
        </div>
      )}
    </div>
  );
};
